import React from 'react';
import { Button, CircularProgress, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    position: 'relative',
  },
  buttonProgress: {
    color: theme.palette.primary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));


// Button that displays spinner to indicate pending state
export const LoadingButton = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Button
        
        {...props.buttonProps}
        disabled={props.buttonProps.disabled || props.loading}
      >
        {props.children}
      </Button>
      {props.loading && <CircularProgress size={24} className={classes.buttonProgress} /> }
    </div>
  )
}